import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-45a62fb8"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src", "alt"]

import { computed, ref } from 'vue';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
// import ColorThief from 'colorthief';
// const colorThief = new ColorThief();


export default /*#__PURE__*/_defineComponent({
  __name: 'CategoryCard',
  props: {
    image: {},
    label: {},
    colorScheme: {}
  },
  setup(__props: any) {

const props = __props;



const imageEl = ref<HTMLImageElement>();
const encodedLabel = computed(() =>
  encodeURIComponent(props.label.toLowerCase().replaceAll(' ', '-')),
);

// const getDominantColor = () => {
//   try {
//     const dominantColor = colorThief.getColor(imageEl.value);
//   } catch (error) {
//     console.log(error);
//   }
// };

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_component_router_link, {
    to: { name: 'products', query: { category: encodedLabel.value } }
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: "category",
        style: _normalizeStyle({ background: _ctx.colorScheme?.bgColor })
      }, [
        _createElementVNode("img", {
          src: _ctx.image,
          alt: _ctx.label,
          ref_key: "imageEl",
          ref: imageEl
        }, null, 8, _hoisted_1),
        _createElementVNode("span", {
          class: "label",
          style: _normalizeStyle({ color: _ctx.colorScheme?.color })
        }, _toDisplayString(_ctx.label), 5)
      ], 4)
    ]),
    _: 1
  }, 8, ["to"]))
}
}

})